
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";

import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components

function EditProductVarinat() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  //   alignItems: "center",
                  gap: "5px",
                  marginTop: "5vh",
                }}
              >
                <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>Master Product*</span>
                <select
                  style={{
                    width: "60vw",
                    border: "1px solid gray",
                    outline: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    height: "7vh",
                  }}
                  name=""
                  id=""
                >
                  <option value="">Winter casual trousers</option>
                  <option value="">Summer quick dry trousers</option>
                  <option value="">summer casula jumpsuit</option>
                  <option value="">casual pants</option>
                </select>
              </div>

              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Product id"
                variant="outlined"
              />

              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size Path"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="OCR size"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size1"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size2"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size3"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size4"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size5"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size6"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size7"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Size8"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Attribute number"
                variant="outlined"
              />

              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="First Attribute Display name"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="First Attribute value"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Sku image url path"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Second Attribute Display Name"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Second attribute value"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Thir Attribute Display name"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Third attribute value"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Amount on Sale Total"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Price"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Sku id"
                variant="outlined"
              />
              <TextField
                required
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Special id"
                variant="outlined"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10vh",
            }}
          >
            <Button title={"Submit"} />
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditProductVarinat;

